export const messages = {
  unsupportedConfiguration: 'The offer configuration is not supported for editing.',
  viewOriginalOffer: 'View the original offer',
};
